export default __webpack_public_path__ + "static/media/uploader-caresens-4.bcdd60ea.png";